import React, { useMemo } from "react";
import { PrismBanner } from "@prism-ui/react";
import PrismDataGrid from "../../../shared/PrismDataGrid";
import "./EducationTable.css";

const COLUMNS = [
  {
    id: "description",
    header: "Institution/Degree Earned",
    accessor: (row) => row.description ?? "",
  },
  {
    id: "attainment_year",
    header: "Year Attained",
    align: "center",
    width: "160px",
    accessor: (row) => row.attainment_year ?? "",
  },
];

const EducationTable = (props) => {
  const rows = useMemo(
    () =>
      props.educationEntries
        // Row ids come from the entry's position in the *unsorted* prop so they stay
        // stable when sorting reorders the list. Unsaved entries have no `id`.
        .map((education, index) => ({
          ...education,
          _rowId:
            education.id != null
              ? `education-${education.id}`
              : `education-idx-${index}`,
        }))
        .sort((a, b) => (b.attainment_year || 0) - (a.attainment_year || 0)),
    [props.educationEntries]
  );

  if (props.educationEntries.length === 0)
    return (
      <PrismBanner tone="secondary" layout="inline">
        You have not entered your education history
      </PrismBanner>
    );

  return (
    <div className="education-table">
      <PrismDataGrid
        keyField="_rowId"
        caption="Education history"
        data={rows}
        columns={COLUMNS}
      />
    </div>
  );
};

export default EducationTable;
